import React from 'react';
import {useFetchTask} from '@rocket-ui/lk-api';
import {useParams} from 'react-router-dom';
import {Order} from 'widgets/order-details';
import styles from 'widgets/order-details/ui/OrderPage.module.css';

export function OrderPage(): React.ReactElement {
	const {orderId} = useParams<{orderId: string}>();
	const {
		data: task,
		isLoading,
		isError,
		error,
		refetch,
	} = useFetchTask(
		{id: orderId ?? ''},
		{
			enabled: Boolean(orderId),
		},
	);

	React.useEffect(() => {
		if (!orderId) return;
		if (task?.status !== 'draft') return;

		const intervalId = window.setInterval(refetch, 10_000);

		return () => {
			window.clearInterval(intervalId);
		};
	}, [orderId, task?.status, refetch]);

	if (!orderId) return <p className={styles.errorText}>Некорректный id заказа.</p>;
	if (isLoading) return <p className={styles.stateText}>Загрузка заказа...</p>;
	if (isError) {
		return <p className={styles.errorText}>{error instanceof Error ? error.message : 'Не удалось загрузить заказ'}</p>;
	}
	if (!task) return <p className={styles.stateText}>Заказ не найден.</p>;

	return <Order task={task} />;
}
